/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ChallengeResolutionResolutionType = {
  RoleAssigned: "role_assigned",
  Dismissed: "dismissed",
} as const;
export type ChallengeResolutionResolutionType = OpenEnum<
  typeof ChallengeResolutionResolutionType
>;

export type ChallengeResolution = {
  /**
   * ClickHouse challenge ID.
   */
  challengeId: string;
  createdAt: Date;
  /**
   * Resolution record ID.
   */
  id: string;
  /**
   * Organization ID.
   */
  organizationId: string;
  /**
   * Denied principal.
   */
  principalUrn: string;
  resolutionType: ChallengeResolutionResolutionType;
  /**
   * Admin who resolved.
   */
  resolvedBy: string;
  /**
   * Resource ID.
   */
  resourceId?: string | undefined;
  /**
   * Resource kind.
   */
  resourceKind?: string | undefined;
  /**
   * Assigned role slug.
   */
  roleSlug?: string | undefined;
  /**
   * Denied scope.
   */
  scope: string;
};

/** @internal */
export const ChallengeResolutionResolutionType$inboundSchema: z.ZodMiniType<
  ChallengeResolutionResolutionType,
  unknown
> = openEnums.inboundSchema(ChallengeResolutionResolutionType);

/** @internal */
export const ChallengeResolution$inboundSchema: z.ZodMiniType<
  ChallengeResolution,
  unknown
> = z.pipe(
  z.object({
    challenge_id: z.string(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    organization_id: z.string(),
    principal_urn: z.string(),
    resolution_type: ChallengeResolutionResolutionType$inboundSchema,
    resolved_by: z.string(),
    resource_id: z.optional(z.string()),
    resource_kind: z.optional(z.string()),
    role_slug: z.optional(z.string()),
    scope: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "challenge_id": "challengeId",
      "created_at": "createdAt",
      "organization_id": "organizationId",
      "principal_urn": "principalUrn",
      "resolution_type": "resolutionType",
      "resolved_by": "resolvedBy",
      "resource_id": "resourceId",
      "resource_kind": "resourceKind",
      "role_slug": "roleSlug",
    });
  }),
);

export function challengeResolutionFromJSON(
  jsonString: string,
): SafeParseResult<ChallengeResolution, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ChallengeResolution$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ChallengeResolution' from JSON`,
  );
}
